var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#F9F7FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4053_35576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 14.078C38.81 14.6 37.542 14.946 36.22 15.114C37.58 14.302 38.618 13.026 39.106 11.488C37.838 12.244 36.438 12.778 34.946 13.076C33.742 11.794 32.026 11 30.154 11C26.522 11 23.598 13.948 23.598 17.562C23.598 18.082 23.642 18.582 23.75 19.058C18.296 18.792 13.47 16.178 10.228 12.196C9.662 13.178 9.33 14.302 9.33 15.512C9.33 17.784 10.5 19.798 12.244 20.964C11.19 20.944 10.156 20.638 9.28 20.156C9.28 20.176 9.28 20.202 9.28 20.228C9.28 23.416 11.554 26.064 14.536 26.674C14.002 26.82 13.42 26.89 12.816 26.89C12.396 26.89 11.972 26.866 11.574 26.778C12.424 29.376 14.836 31.286 17.704 31.348C15.472 33.094 12.638 34.146 9.57 34.146C9.032 34.146 8.516 34.122 8 34.056C10.906 35.93 14.35 37 18.064 37C30.136 37 36.736 27 36.736 18.332C36.736 18.042 36.726 17.762 36.712 17.484C38.014 16.56 39.108 15.406 40 14.078Z",
    fill: "#1B4458",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4053_35576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.3700a17f2ee01332f952e2fc711bb60e.svg";
export { ForwardRef as ReactComponent };